import { CommonModule } from '@angular/common';
import { Component, computed, effect, input, OnDestroy } from '@angular/core';
import { ActionButtonComponent } from 'src/app/home-page/components/action-button/action-button.component';
import { IActionButtonData } from 'src/app/home-page/components/action-button/IActionButtonData.model';
import { ProductCardComponent } from '@core/components/product-card/product-card.component';
import { Subject, takeUntil } from 'rxjs';
import { BootstrapQueryService } from 'src/app/home-page/services/bootstrap-query.service';
import { PromotionalBannerModel } from 'src/app/home-page/models/promotional-banner.model';
import { NavigationService } from '@core/services/navigation.service';

@Component({
  selector: 'cgw-banner-promo',
  standalone: true,
  imports: [ProductCardComponent, CommonModule, ActionButtonComponent],
  templateUrl: './banner-promo.component.html',
  styleUrl: './banner-promo.component.scss',
})
export class BannerPromoComponent implements OnDestroy {
  private readonly _destroyS = new Subject<boolean>();

  public readonly dataBanner = input.required<PromotionalBannerModel>();

  public backgroundImage: string | undefined;
  public readonly moreButton = computed<IActionButtonData>(() => ({
    type: 'primary',
    title: 'Ver productos',
    action: () => {
      this._navigationService.navigateToUrl(this.dataBanner().buttonViewProductsDesc);
    },
  }));

  constructor(
    private _bootstrapQueryService: BootstrapQueryService,
    private _navigationService: NavigationService,
  ) {
    this.manageImage();
  }

  public ngOnDestroy(): void {
    this._destroyS.next(true);
    this._destroyS.complete();
  }

  private manageImage(): void {
    effect(() => {
      this._destroyS.next(true);
      this._bootstrapQueryService
        .getImageQuery(this.dataBanner().images)
        .pipe(takeUntil(this._destroyS))
        .subscribe((img) => {
          this.backgroundImage = img;
        });
    });
  }
}
